import React from 'react'
import * as Sentry from '@sentry/browser'
import { Route } from 'react-router-dom'

// Core
import { MagentoCountryCodeEnum } from 'lib/types'
import { localStorage } from 'lib/core/services/localStorage'
import { PWA, Switch, PrivateRoute } from 'lib/core/components'
import { ThemeProvider } from 'lib/ui'
import { Main } from 'lib/modules/shared'

// Project
import { livBriteTheme } from 'app/livbrite/resources/theme'
import { GlobalStyle } from './components/GlobalStyle'
import { CMS_BLOCK as cmsBlocks } from 'app/livbrite/resources/constants'
import { ModalGlobalStyle } from 'components/Modal'
import { translations } from './resources/translations'
import { EntityResolver } from './components/EntityResolver'
import { Layout } from './components/Layout'
import { Checkout } from './scenes/Checkout'
import { Home } from './scenes/Home'
import { Customer } from './scenes/Customer'
import { Login } from './scenes/Customer/scenes/Account/scenes/Login'
import { CreateAccount } from './scenes/Customer/scenes/Account/scenes/Create'
import { Cart } from './scenes/Cart'
import { Blog } from './scenes/Blog'
import { ProductSelector } from './scenes/ProductSelector'
import { WellnessSurvey } from './scenes/WellnessSurvey'
import { WellnessSurveyResults } from './scenes/WellnessSurveyResults'
import { OrdersAndReturns } from 'scenes/OrdersAndReturns'
import * as data from 'data'
import { SearchScene } from 'scenes/Search'
import { ForgotPassword } from 'scenes/ForgotPassword'
import { ResetPassword } from 'scenes/ResetPassword'
import { ConfirmAccount } from 'lib/shared/scenes/ConfirmAccount'
import { RecommendationProvider } from './components/CustomerResults'

export const Index = () => {
  return (
    <PWA
      checkoutCountries={[MagentoCountryCodeEnum.US]}
      data={data}
      cmsBlocks={cmsBlocks}
      translations={translations}
      onError={(error, errorInfo) => {
        Sentry.withScope((scope) => {
          const user = localStorage.get('user')
          scope.setUser(user)
          scope.setExtras({
            errorInfo,
            user
          })
          Sentry.captureException(error)
        })
      }}
      route={{
        cart: { component: Cart },
        checkout: { component: Checkout },
        createAccount: { component: CreateAccount },
        confirmAccount: { component: ConfirmAccount },
        customer: { component: Customer },
        forgotPassword: { component: ForgotPassword },
        resetPassword: { component: ResetPassword },
        login: { component: Login },
        search: { component: SearchScene }
      }}
    >
      <ThemeProvider theme={livBriteTheme}>
        <RecommendationProvider>
          <Main layout={Layout}>
            <Layout>
              <Switch entityResolver={EntityResolver}>
                <Route path='/product-selector' component={ProductSelector} />
                <PrivateRoute path='/wellness-survey' exact component={WellnessSurvey} />
                <PrivateRoute path='/wellness-survey/results' component={WellnessSurveyResults} />
                <Route path='/blog' component={Blog} />
                <Route path='/sales' component={OrdersAndReturns} />
                <Route exact path='/' component={Home} />
              </Switch>
            </Layout>
          </Main>
        </RecommendationProvider>
        <GlobalStyle />
        <ModalGlobalStyle />
      </ThemeProvider>
    </PWA>
  )
}
